<div class="std-margin text-right">
  <date-picker [force]="true" [handler]="handler"></date-picker>
</div>
<panel *ngIf="!loading && range">

  <ng-container header *ngFor="let i of paths; index as ix">
    <span *ngIf="ix > 0" class="hlf-margin-left hlf-margin-right">|</span>
    <span *ngIf="ix != 1" [ngClass]="{'pointer text-primary': i.children.length > 0 && i != good}" (click)="open(i)">{{i.name}}</span>
    <good *ngIf="ix == 1" [sku]="i.name" [ngClass]="{'pointer text-primary': i.children.length > 1 && i != good}" (click)="open(i)"></good>
  </ng-container>


  <text-filter *ngIf="details.empty" [target]="goods" [placeholder]="'Tìm mã hàng'" right></text-filter>
  <text-filter *ngIf="!details.empty" [target]="details" [placeholder]="'Tìm khách hàng'" right></text-filter>

  <table responsive class="data hover" *ngIf="details.empty">
    <tr>
      <th priority="7" style="width: 0" class="text-right text-top">STT</th>
      <th priority="1"><sortable [target]="goods" [extractor]="extractor('SKU')">{{'Mã hàng' | lang}}</sortable></th>
      <th priority="2" class="text-center">{{'Mã màu' | lang}}</th>
      <th priority="6" class="text-center"><sortable [target]="goods" [extractor]="extractor('Count')">{{'Đặt hàng' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="goods" [extractor]="extractor('ImportUnitPriceChanges')">{{'Đổi giá nhập' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="goods" [extractor]="extractor('ExportUnitPriceChanges')">{{'Đổi giá bán' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="goods" [extractor]="extractor('ConversionChanges')">{{'Đổi tỷ giá' | lang}}</sortable></th>
    </tr>
    <tr *ngFor="let i of goods.pageMatches; index as ix" class="pointer" (click)="open(i)">
      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td><good class="bold spacy text-primary nowrap" [sku]="i.SKU"></good></td>
      <td [ngClass]="{'text-right': i.children.length > 0}">
        <ng-container *ngIf="i.children.length > 0">
          <number [good]="'none'" [sign]="false" [value]="i.Colors.length"></number><unit>{{'màu' | lang}}</unit>
        </ng-container>
        <span *ngIf="i.children.length < 1" class="bold text-warning uppercase">{{i.Colors[0]}}</span>
      </td>
      <td>
        <number [good]="'none'" [sign]="false" [value]="i.records.length"></number>
        <unit>{{'lần' | lang}}</unit>
      </td>
      <td>
        <ng-container *ngIf="i.ImportUnitPriceChanges > 0">
          <number [sign]="false" [good]="trend(i, 'ImportUnitPrice', true)" [value]="i.ImportUnitPriceRange.from"></number><cny></cny> ~ <number [sign]="false" [good]="trend(i, 'ImportUnitPrice', true)" [value]="i.ImportUnitPriceRange.to"></number><cny></cny>
        </ng-container>
        <div>
          <number [good]="trend(i,'ImportUnitPrice')" [sign]="false" [value]="i.ImportUnitPriceChanges"></number>
          <unit>{{'lần' | lang}}</unit>
        </div>
      </td>
      <td class="nowrap">
        <ng-container *ngIf="i.ExportUnitPriceChanges > 0">
          <number [sign]="false" [good]="trend(i,'ExportUnitPrice')" [value]="i.ExportUnitPriceRange.from"></number><vnd></vnd> ~ <number [sign]="false" [good]="trend(i, 'ExportUnitPrice')" [value]="i.ExportUnitPriceRange.to"></number><vnd></vnd>
        </ng-container>
        <div>
          <number [good]="'negative'" [sign]="false" [value]="i.ExportUnitPriceChanges"></number>
          <unit>{{'lần' | lang}}</unit>
        </div>
      </td>
      <td class="nowrap">
        <ng-container *ngIf="i.ConversionChanges > 0">
          <number [sign]="false" [good]="trend(i,'Conversion', true)" [value]="i.ConversionRange.from"></number><vnd-per-cny></vnd-per-cny> ~ <number [sign]="false" [good]="trend(i,'Conversion', true)" [value]="i.ConversionRange.to"></number><vnd-per-cny></vnd-per-cny>
        </ng-container>
        <div>
          <number [good]="'negative'" [sign]="false" [value]="i.ConversionChanges"></number>
          <unit>{{'lần' | lang}}</unit>
        </div>
      </td>
    </tr>
    <tr class="footer" *ngIf="goods.pages.length > 1">
      <td [colSpan]="7" class="text-center" style="display: table-cell !important">
        <pagination [target]="details"></pagination>
      </td>
    </tr>

  </table>

  <table responsive class="data" *ngIf="!details.empty">
    <tr>
      <th priority="6" style="width: 0" class="text-right text-top">STT</th>
      <th priority="1" class="text-top">{{'Ngày' | lang}}</th>
      <th priority="2" class="text-top text-center">{{'Khách hàng' | lang}}</th>
      <th priority="4" class="text-top text-right">{{'Giá nhập' | lang}}</th>
      <th priority="3" class="text-top text-right">{{'Giá bán' | lang}}</th>
      <th priority="5" class="text-top text-right">{{'Tỷ giá' | lang}}</th>
    </tr>
    <tr *ngFor="let i of details.pageMatches; index as ix">
      <td><small>{{ix + 1 + goods.pageIndex * goods.pageSize}}</small></td>
      <td class="nowrap">{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td class="bold uppercase">{{i.Customer}}</td>
      <td>
        <number [sign]="false" [good]="i.ImportUnitPriceTrend" [value]="i.ImportUnitPrice"></number><cny></cny>
      </td>
      <td class="nowrap">
        <number [sign]="false" [good]="i.ExportUnitPriceTrend" [value]="i.ExportUnitPrice"></number><vnd></vnd>
      </td>
      <td class="nowrap">
        <number [sign]="false" [good]="i.ConversionTrend" [value]="i.Conversion"></number><vnd-per-cny></vnd-per-cny>
      </td>
    </tr>
    <tr class="footer" *ngIf="details.pages.length > 1">
      <td [colSpan]="6" class="text-center" style="display: table-cell !important">
        <pagination [target]="details"></pagination>
      </td>
    </tr>
  </table>
</panel>

<ngx-loading [show]="loading"></ngx-loading>
